import Card from '@components/undock/cards'
import { Theme, themesMap } from '@components/undock/modules'
import styled from '@emotion/styled'
import { mediaQueries } from '@lib/mediaQueries'

interface CardDescriptionPropsI {
  theme?: Theme
}
export const CardDescription = styled.p<CardDescriptionPropsI>(
  {
    lineHeight: 1.5,
    margin: '1rem 0 0',
    padding: 0,
  },
  ({ theme = themesMap.light }) => ({
    color: theme.colors.cardTextColor,
  })
)

interface CardLabelPropsI {
  color?: string
  theme?: Theme
}
export const CardLabel = styled.span<CardLabelPropsI>(
  {
    display: 'block',
    fontFamily: '"Inter", sans-serif',
  },
  ({ color = null, theme = themesMap.light }) => ({
    color: color ? color : theme.colors.cardLabelColor,
  })
)

interface CardPriceLabelPropsI {
  theme?: Theme
}
export const CardPriceLabel = styled.span<CardPriceLabelPropsI>(
  {
    display: 'inline-block',
    fontSize: '1.25rem',
    fontWeight: 400,
    marginLeft: '.25rem',
  },
  ({ theme = themesMap.light }) => ({
    color: theme.colors.cardTextColor,
  })
)

interface CardPricePropsI {
  color?: string
  theme?: Theme
}
export const CardPrice = styled.div<CardPricePropsI>(
  {
    alignItems: 'center',
    display: 'flex',
    fontSize: '3rem',
    marginTop: '1rem',
  },
  ({ color = null, theme = themesMap.light }) => ({
    color: color ? color : theme.colors.headlineColor,
  })
)

export const CtaWrapper = styled.div({
  marginTop: '2rem',
  a: {
    width: '100%',
  },
})

interface ListItemPropsI {
  theme?: Theme
}
export const ListItem = styled.div<ListItemPropsI>(
  {
    fontWeight: 400,
    '&:not(:first-of-type)': {
      marginTop: '.5rem',
    },
  },
  ({ theme = themesMap.light }) => ({
    color: theme.colors.headlineColor,
  })
)

export const ListItems = styled.div({
  marginTop: '2rem',
})

export const CardsWrapper = styled.div(
  mediaQueries({
    display: 'flex',
    flexWrap: ['wrap', 'wrap', 'wrap', 'nowrap'],
    justifyContent: 'space-between',
    marginBottom: '4rem',
    marginTop: '4rem',
    width: '100%',
    [`${Card}`]: {
      width: ['100%', '100%', '100%', 'calc((100%/3) - (4rem/3))'],
    },
  })
)

export const ContentWrapper = styled.div({
  textAlign: 'center',
  width: '100%',
})

export const PricingWrapper = styled.div({})
